import { useState } from 'react';
import DocumentPages from '../AddDocument/DocumentPages';
import Content from './Content/Content';
import ContentMask from './ContentMask/ContentMask';
import Tray from './Tray/Tray';
import {isMobile} from 'react-device-detect';
import TranslatedContent from './TranslatedContent/TranslatedContent';
import { useSession } from '../../common/session/SessionContext';

const Home = () => {
  
  const { activeDocument } = useSession();
  const [openTrayEditDocument, setOpenTrayEditDocument] = useState(false);

  const openTray = () => {
    setOpenTrayEditDocument(true);
  };

  const closeTray = () => {
    setOpenTrayEditDocument(false);
  };

  return (
    <TranslatedContent>
      <Content openTray={openTray} />
      <Tray
        isTrayOpen={openTrayEditDocument}
        closeTray={closeTray}
      >
        {/*
          The openTrayEditDocument state variable will already hide this by hiding the tray.
          But if we do not control rendering the DocumentPages component with this condition,
          then its state is preserved and clicking 'Cancel' to hide the tray will not undo any
          state changes that took place within the component.
        */}
        {openTrayEditDocument &&
        <DocumentPages
          document={activeDocument}
          isMobile={isMobile}
          headerTitleAlign="center"
          headerTitleSize="small"
          onFinish={closeTray}
          onCancel={closeTray}
        />
        }
      </Tray>
      <ContentMask
        isTrayOpen={openTrayEditDocument}
        closeTray={closeTray}
      />
    </TranslatedContent>
  );
};

export default Home;